export default class RecipientReadModel {
  ofClient(clientId) {}
}
